module.exports = __webpack_public_path__ + "static/media/init_editor.f0fc2734.svg";